export enum HeaderStyle {
  HEADER_1 = 'h1',
  HEADER_2 = 'h2',
  HEADER_3 = 'h3',
  HEADER_4 = 'h4',
  HEADER_5 = 'h5',
  HEADER_6 = 'h6',
}

export enum ButtonType {
  ICON = 'icon',
  TEXT = 'text',
}

export enum HeaderFlex {
  CENTER = 'center',
  END = 'end',
  START = 'start',
  SPACE_BETWEEN = 'space-between',
}
